// ENGLISH ENTRY POINT
// Entry points need to exists inside of webpack.config.js under module.exports, entry:
// Entry points is meant for the translations object.
// _english.js is meant for custom functions for the english hub.
// _en.scss is meant for custom stylings for the english hub.

require('../partials/hubSpecificStyles/_en.scss');
const hubSpecificJS = require('../scriptPartials/hubSpecificFunctions/_english.js');
const onbrandScripts = require('../onbrand.js');

//only use if there are descrepencies between different language sites.
const generateLinks = (arr) => {
  return arr.map((link) => `<a href="${link.href}" id="${link.id}">${link.label}</a>`).join('');
};

const translations = {
  header: {
    logo: {
      link: 'https://www.axway.com/en',
    },
    products: {
      products: {
        link: '',
        label: 'Products',
      },
      amplifyPlatform: {
        label: 'AMPLIFY Platform',
      },
      tryPromotion: {
        link: 'https://platform.axway.com/#/signup/',
        label: 'Try it now!',
      },
      amplifyOverview: {
        link: 'https://www.axway.com/en/products/amplify',
        label: 'AMPLIFY Overview',
      },
      whyAmplify: {
        link: 'https://www.axway.com/en/products/amplify/why-amplify',
        label: 'Why AMPLIFY?',
      },
      hybridIntegration: {
        link: 'https://www.axway.com/en/products/amplify/hybrid-integration-platform',
        label: 'Hybrid Integration',
      },
      login: {
        link: 'https://platform.axway.com/',
        label: 'Login / Register',
      },
      amplifyProducts: {
        label: 'AMPLIFY Products',
      },
      apiManagement: {
        link: 'https://www.axway.com/en/products/api-management',
        label: 'API Management',
      },
      managedFile: {
        link: 'https://www.axway.com/en/products/managed-file-transfer',
        label: 'Managed File Transfer',
      },
      contentCollab: {
        link: 'https://www.axway.com/en/products/content-collaboration',
        label: 'Content Collaboration',
      },
      b2bIntegration: {
        link: 'https://www.axway.com/en/products/b2b-integration',
        label: 'B2B Integration',
      },
      appDevelopment: {
        link: 'https://www.axway.com/en/products/app-development',
        label: 'Application Development',
      },
      analytics: {
        link: 'https://www.axway.com/en/products/analytics',
        label: 'Analytics',
      },
      applicationIntegration: {
        link: 'https://www.axway.com/en/products/amplify/amplify-application-integration',
        label: 'Application Integration',
      },
      specializedProducts: {
        label: 'Specialized Products',
      },
      aiSuite: {
        link: 'https://www.axway.com/en/products/accounting-integration-suite',
        label: 'AI Suite',
      },
      automator: {
        link: 'https://www.axway.com/en/products/axway-automator',
        label: 'Automator',
      },
      mailgate: {
        link: 'https://www.axway.com/en/products/mailgate-sc',
        label: 'MailGate',
      },
      sentinel: {
        link: 'https://www.axway.com/en/products/axway-sentinel',
        label: 'Sentinel',
      },
      otherProducts: {
        link: 'https://www.axway.com/en/products/other-products',
        label: 'Other products',
      },
    },
    solutions: {
      solutions: {
        link: '',
        label: 'Solutions',
      },
      industry: {
        label: 'Industry',
      },
      automotive: {
        link: 'https://www.axway.com/en/solutions/automotive',
        label: 'Automotive',
      },
      banking: {
        link: 'https://www.axway.com/en/solutions/financial-services',
        label: 'Banking & Financial Services',
      },
      healthcare: {
        link: 'https://www.axway.com/en/solutions/healthcare',
        label: 'Healthcare',
      },
      insurance: {
        link: 'https://www.axway.com/en/solutions/insurance',
        label: 'Insurance',
      },
      lifeSciences: {
        link: 'https://www.axway.com/en/solutions/life-science',
        label: 'Life Sciences',
      },
      manufacturing: {
        link: 'https://www.axway.com/en/solutions/manufacturing-cpg',
        label: 'Manufacturing & CPG',
      },
      retail: {
        link: 'https://www.axway.com/en/solutions/retail',
        label: 'Retail',
      },
      transportation: {
        link: 'https://www.axway.com/en/solutions/transportation-logistics',
        label: 'Transportation & Logistics',
      },
      usFedGov: {
        link: 'https://www.axway.com/en/solutions/government',
        label: 'US Federal Government',
      },
      businessDriver: {
        label: 'Business Driver',
      },
      modernizeIT: {
        link: 'https://www.axway.com/en/solutions/modernize-it',
        label: 'Modernize IT',
      },
      innovation: {
        link: 'https://www.axway.com/en/solutions/innovation',
        label: 'Innovation',
      },
      hybridIntegration: {
        link: 'http://interactive.axway.com/hybrid-integration-drivers/p/1',
        label: 'The Drive to Hybrid Integration',
      },
    },
    services: {
      services: {
        link: '',
        label: 'Services',
      },
      support: {
        link: 'https://www.axway.com/en/services/support',
        label: 'Support',
      },
      catalyst: {
        link: 'https://www.axway.com/en/catalysts',
        label: 'Catalyst',
      },
      consulting: {
        link: 'https://www.axway.com/en/catalysts',
        label: 'Consulting',
      },
      training: {
        link: 'https://www.axway.com/en/services/training-certification',
        label: 'Training & Certification',
      },
      griffin: {
        link: 'https://www.axway.com/en/services/griffin-innovation-lab',
        label: 'Griffin Innovation Lab',
      },
    },
    resources: {
      resources: {
        link: '',
        label: 'Resources',
      },
      assetLibrary: {
        link: 'https://www.axway.com/en/resources/asset-library',
        label: 'Asset Library',
      },
      webinars: {
        link: 'https://www.axway.com/en/resources/webinar',
        label: 'Webinars',
      },
      videos: {
        link: 'https://www.axway.com/en/resources/videos',
        label: 'Videos',
      },
      blogs: {
        link: 'https://www.axway.com/en/resources/blogs',
        label: 'Blogs',
      },
      marketplace: {
        link: 'https://www.axway.com/en/resources/marketplace',
        label: 'Marketplace',
      },
      developerPortal: {
        link: 'https://developer.axway.com/',
        label: 'Developer Portal',
      },
      digitalMaturityAssessment: {
        link: 'https://www.axway.com/en/maturity-assessment',
        label: 'Digital Maturity Assessment',
      },
      hybridIntegrationAssessment: {
        link: 'https://www.axway.com/en/hybrid-integration-benchmark-assessment',
        label: 'Hybrid Integration Assessment',
      },
      connectNewsletter: {
        link: 'https://www.axway.com/en/resources/axway-connect',
        label: 'CONNECT Newsletter',
      },
    },
    company: {
      company: {
        link: '',
        label: 'Company',
      },
      about: {
        link: 'https://www.axway.com/en/company/about-axway',
        label: 'About',
      },
      griffin: {
        link: 'https://www.axway.com/en/company/axway-griffin',
        label: 'The Griffin',
      },
      careers: {
        link: 'https://www.axway.com/en/company/careers',
        label: 'Careers',
      },
      investorRelations: {
        link: 'http://www.investors.axway.com/',
        label: 'Investor Relations',
      },
      events: {
        link: 'https://www.axway.com/en/company/events',
        label: 'Events',
      },
      media: {
        link: 'https://www.axway.com/en/company/media',
        label: 'Media',
      },
      analystRecognition: {
        link: 'https://www.axway.com/en/company/analyst-recognition',
        label: 'Analyst Recognition',
      },
      leadership: {
        link: 'https://www.axway.com/en/company/leadership',
        label: 'Leadership',
      },
      rdManifesto: {
        link: 'https://www.axway.com/en/company/rd-manifesto',
        label: 'R&D Manifesto',
      },
      legalContracts: {
        link: 'https://www.axway.com/en/legal/contract-documents',
        label: 'Legal Contracts',
      },
    },
    partners: {
      partners: {
        link: '',
        label: 'Partners',
      },
      partnerCommunity: {
        label: 'Partner Community',
      },
      findAPartner: {
        link: 'https://www.axway.com/en/partners/find-partner',
        label: 'Find a partner',
      },
      becomeAPartner: {
        link: 'https://www.axway.com/en/partners/become-partner',
        label: 'Become a partner',
      },
      resources: {
        link: 'https://www.axway.com/en/partners/resources',
        label: 'Resources',
      },
      partnerLogin: {
        link: 'https://axway.channeltivity.com/Login',
        label: 'Partner login',
      },
      marketplace: {
        label: 'Marketplace',
      },
      marketplaceProgram: {
        link: 'https://www.axway.com/en/partners/marketplace',
        label: 'Marketplace Program',
      },
    },
    customers: {
      customers: {
        label: 'Customers',
      },
      customerStories: {
        link: 'https://www.axway.com/en/customers/customer-stories',
        label: 'Customer Stories',
      },
      customerAdvocacy: {
        link: 'https://www.axway.com/en/support/axway-customer-advocacy-program',
        label: 'Customer Advocacy',
      },
      quarterlyNewsletter: {
        link: 'https://www.axway.com/en/customers/quarterly-newsletter',
        label: 'Quarterly Newsletter',
      },
      userGroups: {
        link: 'https://community.axway.com/s/event-list/',
        label: 'User Group Program',
      },
      documentation: {
        link: 'https://docs.axway.com/',
        label: 'Documentation',
      },
      support: {
        link: 'https://support.axway.com',
        label: 'Support',
      },
      community: {
        link: 'https://community.axway.com/s/',
        label: 'Community',
      },
      developers: {
        link: 'https://developer.axway.com/',
        label: 'Developers',
      },
      platformLogin: {
        link: 'https://platform.axway.com/',
        label: 'Platform login',
      },
    },
  },
  footer: {
    footerIntroText: {
      label: `When you work with Axway, you can be confident that our award-winning solutions will
      empower your business to thrive in the digital economy.`,
    },
    about: {
      link: 'https://www.axway.com/en/company/about-axway',
      label: 'About',
    },
    partners: {
      link: 'https://www.axway.com/en/partners/find-partner',
      label: 'Partners',
    },
    careers: {
      link: 'https://www.axway.com/en/company/careers',
      label: 'Careers',
    },
    resourceLibrary: {
      link: 'https://www.axway.com/en/resources/asset-library',
      label: 'Resource Library',
    },
    events: {
      link: 'https://www.axway.com/en/company/events',
      label: 'Events',
    },
    press: {
      link: 'https://www.axway.com/en/company/media',
      label: 'Press',
    },
    contactUs: {
      link: 'https://www.axway.com/en/contact-us',
      label: 'Contact Us',
    },
    locations: {
      link: 'https://www.axway.com/en/locations',
      label: 'Locations',
    },
    investorRelations: {
      link: 'https://investors.axway.com',
      label: 'Investor Relations',
    },
    legalContracts: {
      link: 'https://www.axway.com/en/legal/contract-documents',
      label: 'Legal Contracts',
    },
    termsOfUse: {
      link: 'https://www.axway.com/en/terms-of-use',
      label: 'Terms of Use',
    },
    privacyStatement: {
      link: 'https://www.axway.com/en/privacy-policy',
      label: 'Privacy Statement',
    },
    ethics: {
      link: 'https://www.axway.com/en/code-of-ethics',
      label: 'Code of Ethics',
    },
    gdpr: {
      link: 'https://www.axway.com/en/gdpr',
      label: 'Privacy Compliance Program - GDPR',
    },
    followUs: {
      label: 'Follow Us',
    },
    facebook: {
      link: 'https://www.facebook.com/axwaysoftware/',
    },
    youtube: {
      link: 'https://www.youtube.com/user/AxwaySoftware',
    },
    twitter: {
      link: 'https://twitter.com/axway',
    },
    linkedin: {
      link: 'https://www.linkedin.com/company/axway',
    },
    slideshare: {
      link: 'https://www.slideshare.net/Axway',
    },
    instagram: {
      link: 'https://www.instagram.com/axway_of_life/',
    },
    copyright: {
      label: '© 2019 Axway, All Rights Reserved.',
    },
  },
};

hubSpecificJS();
onbrandScripts.initOnbrand(translations, production);



// WEBPACK FOOTER //
// ./entryPoints/en.js